import { gql } from "@apollo/client";
import {
  ATTRIBUTE_FIELDS,
  GAME_FIELDS,
  SWIPER_CONFIGURATION_FIELDS,
  TRIVIA_CONFIGURATION_FIELDS,
  WORDLE_CONFIGURATION_FIELDS,
} from "../fragments";

export const GAME_ALL = gql`
  ${TRIVIA_CONFIGURATION_FIELDS}
  ${GAME_FIELDS}
  ${SWIPER_CONFIGURATION_FIELDS}
  ${ATTRIBUTE_FIELDS}
  ${WORDLE_CONFIGURATION_FIELDS}
  query GameAll($projectId: String!) {
    gameAll(projectId: $projectId) {
      ...GameFields
      configuration {
        ... on SwiperConfiguration {
          ...SwiperConfigurationFields
          attributes {
            ...AttributeFields
          }
          gameVisuals {
            id
            themeColor
            cardBackImage {
              id
              name
              url
            }
            showIcons
            iconSet
            backgroundColor
            backgroundPositiveColor
            backgroundNegativeColor
            positiveColor
            negativeColor
            backgroundImage {
              id
              name
              url
            }
          }
          welcomePage {
            id
            welcomeLine
            welcomeLineColor
            subheading
            subheadingColor
            tagLine
            tagLineColor
            button
            buttonColor
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
            logo {
              id
              name
              url
            }
          }
          feedbackPage {
            id
            title
            titleColor
            instructionLine
            instructionLineColor
            textBoxPrompt
            textBoxPromptColor
            submitButton
            submitButtonColor
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          gameResults {
            id
            scoreTitle_0_20
            scoreTitle_21_40
            scoreTitle_41_60
            scoreTitle_61_80
            scoreTitle_81_100
            scoreTag_0_20
            scoreTag_21_40
            scoreTag_41_60
            scoreTag_61_80
            scoreTag_81_100
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
        }

        ... on RankifierConfiguration {
          id
          mostQuestion
          leastQuestion
          mostQuestionColor
          leastQuestionColor
          cardsPerHand
          numberOfRounds
          showWelcomePage
          showGameResults
          showFeedbackPage
          attributes {
            ...AttributeFields
          }
          gameVisuals {
            id
            themeColor
            cardBackImage {
              id
              name
              url
            }
            showIcons
            iconSet
            backgroundColor
            backgroundPositiveColor
            backgroundNegativeColor
            positiveColor
            negativeColor
            backgroundImage {
              id
              name
              url
            }
          }
          welcomePage {
            id
            welcomeLine
            welcomeLineColor
            subheading
            subheadingColor
            tagLine
            tagLineColor
            button
            buttonColor
            logo {
              id
              name
              url
            }
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          feedbackPage {
            id
            title
            titleColor
            instructionLine
            instructionLineColor
            textBoxPrompt
            textBoxPromptColor
            submitButton
            submitButtonColor
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          gameResults {
            id
            scoreTitle_0_20
            scoreTitle_21_40
            scoreTitle_41_60
            scoreTitle_61_80
            scoreTitle_81_100
            scoreTag_0_20
            scoreTag_21_40
            scoreTag_41_60
            scoreTag_61_80
            scoreTag_81_100
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
        }

        ... on WordopolisConfiguration {
          id
          topic
          difficulty
          numberOfRows
          numberOfColumns
          isTimeLimited
          limitedTime
          showWords
          startText
          showWelcomePage
          showRatingScale
          ratingQuestion
          ratingLeftLabel
          ratingRightLabel
          ratingScaleSize
          boardBackgroundImage {
            id
            name
            url
          }
          boardBackgroundColor
          boardColor
          board
          attributes {
            ...AttributeFields
          }
          gameVisuals {
            id
            themeColor
            showIcons
            iconSet
            backgroundColor
            backgroundPositiveColor
            backgroundNegativeColor
            positiveColor
            negativeColor
            backgroundImage {
              id
              name
              url
            }
          }
          welcomePage {
            id
            welcomeLine
            welcomeLineColor
            subheading
            subheadingColor
            tagLine
            tagLineColor
            button
            buttonColor
            logo {
              id
              name
              url
            }
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          showLeaderboard
          leaderboardConfiguration {
            id
            nicknameQuestion
            nicknameQuestionColor
            header
            headerColor
            nicknameLabel
            numberOfPlayers
            showTimer
            subheader
            subheaderColor
            tableNicknameLabel
            tableScoreLabel
            tableTimeLabel
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
        }

        ... on QuickRankConfiguration {
          id
          question
          mode
          showRatingScale
          ratingQuestion
          ratingScaleSize
          ratingRightLabel
          ratingLeftLabel
          showWelcomePage
          showGameResults
          showFeedbackPage
          shuffleCards
          attributes {
            ...AttributeFields
          }

          gameVisuals {
            id
            themeColor
            cardBackImage {
              id
              name
              url
            }
            showIcons
            iconSet
            backgroundColor
            backgroundPositiveColor
            backgroundNegativeColor
            positiveColor
            negativeColor
            backgroundImage {
              id
              name
              url
            }
          }

          welcomePage {
            id
            welcomeLine
            welcomeLineColor
            subheading
            subheadingColor
            tagLine
            tagLineColor
            button
            buttonColor
            logo {
              id
              name
              url
            }
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          feedbackPage {
            id
            title
            titleColor
            instructionLine
            instructionLineColor
            textBoxPrompt
            textBoxPromptColor
            submitButton
            submitButtonColor
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          gameResults {
            id
            scoreTitle_0_20
            scoreTitle_21_40
            scoreTitle_41_60
            scoreTitle_61_80
            scoreTitle_81_100
            scoreTag_0_20
            scoreTag_21_40
            scoreTag_41_60
            scoreTag_61_80
            scoreTag_81_100
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          showLeaderboard
          leaderboardConfiguration {
            id
            nicknameQuestion
            nicknameQuestionColor
            header
            headerColor
            nicknameLabel
            numberOfPlayers
            showTimer
            subheader
            subheaderColor
            tableNicknameLabel
            tableScoreLabel
            tableTimeLabel
          }
        }
        ... on TriviaConfiguration {
          ...TriviaConfigurationFields
          showLeaderboard
          leaderboardConfiguration {
            id
            nicknameQuestion
            nicknameQuestionColor
            header
            headerColor
            nicknameLabel
            numberOfPlayers
            showTimer
            subheader
            subheaderColor
            tableNicknameLabel
            tableScoreLabel
            tableTimeLabel
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
        }

        ... on WordleConfiguration {
          ...WordleConfigurationFields
          gameVisuals {
            id
            themeColor
            cardBackImage {
              id
              name
              url
            }
            showIcons
            iconSet
            backgroundColor
            backgroundPositiveColor
            backgroundNegativeColor
            positiveColor
            negativeColor
            backgroundImage {
              id
              name
              url
            }
          }

          welcomePage {
            id
            welcomeLine
            welcomeLineColor
            subheading
            subheadingColor
            tagLine
            tagLineColor
            button
            buttonColor
            logo {
              id
              name
              url
            }
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
          feedbackPage {
            id
            title
            titleColor
            instructionLine
            instructionLineColor
            textBoxPrompt
            textBoxPromptColor
            submitButton
            submitButtonColor
            backgroundColor
            backgroundImage {
              id
              name
              url
            }
          }
        }
      }
    }
  }
`;

export const GAME_ALL_IDS = gql`
  query GameAllIds($projectId: String!) {
    gameAll(projectId: $projectId) {
      id
      name
      kind
      configuration {
        ... on QuickRankConfiguration {
          id
          mode
        }
      }
    }
  }
`;
